import React from 'react';
import './MapStyleButton.css';

interface MapStyleButtonProps {
  onClick: () => void;
}

const MapStyleButton: React.FC<MapStyleButtonProps> = ({ onClick }) => {
  return (
    <button className="map-style-button" onClick={onClick} title="Change Map Styles">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2M6.5 12.5L7.5 16.5L11.5 17.5L7.5 18.5L6.5 22.5L5.5 18.5L1.5 17.5L5.5 16.5L6.5 12.5M17.5 12.5L18.5 16.5L22.5 17.5L18.5 18.5L17.5 22.5L16.5 18.5L12.5 17.5L16.5 16.5L17.5 12.5Z"/>
      </svg>
    </button>
  );
};

export default MapStyleButton;